<template lang="pug">
include /@ibkr/lib.common/src/icon/arrow
include /@ibkr/lib.common/src/icon/basic
ib-col(class="before-32", :class="{'insetx-16': $media.l, 'insetx-4': $media.s}", id="search-res")
    ib-row(class="flex-flex")
        ib-col
            CurrencySelector(hideInfo=true, @update="update")
        ib-col(class="text-right")    
            ib-button(@click="startOver", class="dark-grey-text fw-400 fs6 menu-body") {{ $t('start_over') }}
    div(v-for="(group, index) in groups", :key="index")
        div(v-if="getSelected(group.companies) !== 0")
            ib-row
                ib-col
                    p(class="bold") {{ $t('group') }} {{ index + 1}}
                    div(class="after-12 border-bottom bg-gray80")
                    div(class="after-16")
                        span(class="after-16") {{ $t('ticker_symbol') }}: 
                            span(class="fg-primary", :title="group.companies.filter(comp => comp.selected).map(comp => comp.ticker).join(', ')") {{ group.companies.filter(comp => comp.selected).map(comp => comp.ticker).join(', ') }}
                    p(class="after-16") {{ $t('showing') }} {{ getSelected(group.companies) }} {{ $t('of') }} {{ getSelected(group.companies) }}
            ib-row(class="after_table")
                ib-col(class="scroll", class="flex after-8", style="max-height:65vh;")
                    ib-table-basic(
                        :data="selectedGroup(index)",
                        row,
                        colborder
                        rowstripe,
                        class="fs7 fg70 shrink fin-table",
                        spacing="huge",
                        style="border: 1px solid rgba(0,0,0,0.15); overscroll-behavior:contain;"
                    )
                        ib-table-col(v-if="!$media.xl", width="3ch", sticky)
                            div(class="border-bottom")
                            div
                                span(class="weighted text-right")
                        ib-table-col(width="14ch", sticky)
                            div(class="border-bottom", @click.stop="sortResults('company', '', index)")
                                span(:title="$t('company_name')") {{ $t('company_name') }}
                                span(
                                    class="up", 
                                    :class="{'active-sort': previousSort.type === 'company' && previousSort.dir === 'asc' && previousSort.index === index }", 
                                    @click.stop="sortResults('company', 'asc', index)"
                                )
                                    +icon-arrow-sort_up_filled
                                span(
                                    class="down",
                                    :class="{'active-sort': previousSort.type === 'company' && previousSort.dir === 'desc' && previousSort.index === index }", 
                                    @click.stop="sortResults('company', 'desc', index)"
                                )
                                    +icon-arrow-sort_down_filled
                            div
                                span(:title="$t('weighted_average')") {{ $t('weighted_average') }}
                        ib-table-col(width="8ch")
                            div(class="border-bottom", @click.stop="sortResults('ticker', '', index)")
                                span(:title="$t('ticker')") {{ $t('ticker') }}
                                span(
                                    class="up", 
                                    :class="{'active-sort': previousSort.type === 'ticker' && previousSort.dir === 'asc' && previousSort.index === index  }", 
                                    @click.stop="sortResults('ticker', 'asc', index)"
                                )
                                    +icon-arrow-sort_up_filled
                                span(
                                    class="down",
                                    :class="{'active-sort': previousSort.type === 'ticker' && previousSort.dir === 'desc' && previousSort.index === index }",
                                    @click.stop="sortResults('ticker', 'desc', index)"
                                )
                                    +icon-arrow-sort_down_filled
                            div
                                span(class="weighted text-right") -
                        ib-table-col(width="10ch")
                            div(class="border-bottom", @click.stop="sortResults('country', '', index)")
                                span(:title="$t('country')") {{ $t('country') }}
                                span(
                                    class="up", 
                                    :class="{'active-sort': previousSort.type === 'country' && previousSort.dir === 'asc' && previousSort.index === index }", 
                                    @click.stop="sortResults('country', 'asc', index)"
                                )
                                    +icon-arrow-sort_up_filled
                                span(
                                    class="down",
                                    :class="{'active-sort': previousSort.type === 'country' && previousSort.dir === 'desc' && previousSort.index === index }",
                                    @click.stop="sortResults('country', 'desc', index)"
                                )
                                    +icon-arrow-sort_down_filled
                            div
                                span(class="weighted text-right") -
                        ib-table-col(width="9ch")
                            div(class="border-bottom", @click.stop="sortResults('sector', '', index)")
                                span(:title="$t('sector')") {{ $t('sector') }}
                                span(
                                    class="up", 
                                    :class="{'active-sort': previousSort.type === 'sector' && previousSort.dir === 'asc' && previousSort.index === index }", 
                                    @click.stop="sortResults('sector', 'asc', index)"
                                )
                                    +icon-arrow-sort_up_filled
                                span(
                                    class="down",
                                    :class="{'active-sort': previousSort.type === 'sector' && previousSort.dir === 'desc' && previousSort.index === index }",
                                    @click.stop="sortResults('sector', 'desc', index)"
                                )
                                    +icon-arrow-sort_down_filled
                            div
                                span(class="weighted text-right") -
                        ib-table-col(width="8ch") 
                            div(class="border-bottom")
                                span(:title="$t('price')") {{ $t('price') }}*
                            div
                                span(class="weighted text-right") -
                        ib-table-col(width="10ch")
                            div(class="border-bottom", @click.stop="sortResults('mkt_cap', '', index)")
                                span(:title="$t('mkt_cap')") {{ $t('mkt_cap') }}
                                span(
                                    class="up", 
                                    :class="{'active-sort': previousSort.type === 'mkt_cap' && previousSort.dir === 'asc' && previousSort.index === index }", 
                                    @click.stop="sortResults('mkt_cap', 'asc', index)"
                                )
                                    +icon-arrow-sort_up_filled
                                span(
                                    class="down",
                                    :class="{'active-sort': previousSort.type === 'mkt_cap' && previousSort.dir === 'desc' && previousSort.index === index }",
                                    @click.stop="sortResults('mkt_cap', 'desc', index)"
                                )
                                    +icon-arrow-sort_down_filled
                            div
                                span(class="fg-70 fg-primary text-right weighted") {{ wGroupCaps[index] }}
                        ib-table-col(width="8ch")
                            div(class="border-bottom", @click.stop="sortResults('ev', '', index)")
                                span(:title="$t('ev')") {{ $t('ev') }}
                                span(
                                    class="up", 
                                    :class="{'active-sort': previousSort.type === 'ev' && previousSort.dir === 'asc' && previousSort.index === index }", 
                                    @click.stop="sortResults('ev', 'asc', index)"
                                )
                                    +icon-arrow-sort_up_filled
                                span(
                                    class="down",
                                    :class="{'active-sort': previousSort.type === 'ev' && previousSort.dir === 'desc' && previousSort.index === index }",
                                    @click.stop="sortResults('ev', 'desc', index)"
                                )
                                    +icon-arrow-sort_down_filled
                            div
                                span(class="fg-70 fg-primary text-right weighted") {{  wGroupEVs[index] }}
                        ib-table-col(width="7ch")
                            div(class="border-bottom", @click.stop="sortResults('rev', '', index)")
                                span(:title="$t('rev')") {{ $t('rev') }}
                                span(
                                    class="up", 
                                    :class="{'active-sort': previousSort.type === 'rev' && previousSort.dir === 'asc' && previousSort.index === index }", 
                                    @click.stop="sortResults('rev', 'asc', index)"
                                )
                                    +icon-arrow-sort_up_filled
                                span(
                                    class="down",
                                    :class="{'active-sort': previousSort.type === 'rev' && previousSort.dir === 'desc' && previousSort.index === index }",
                                    @click.stop="sortResults('rev', 'desc', index)"
                                )
                                    +icon-arrow-sort_down_filled
                            div
                                span(class="fg-70 fg-primary text-right weighted") {{ wGroupRevs[index] }}
                        ib-table-col(width="10ch")
                            div(class="border-bottom", @click.stop="sortResults('earnings', '', index)")
                                span(:title="$t('earnings')") {{ $t('earnings') }}
                                span(
                                    class="up", 
                                    :class="{'active-sort': previousSort.type === 'earnings' && previousSort.dir === 'asc' && previousSort.index === index }", 
                                    @click.stop="sortResults('earnings', 'asc', index)"
                                )
                                    +icon-arrow-sort_up_filled
                                span(
                                    class="down",
                                    :class="{'active-sort': previousSort.type === 'earnings' && previousSort.dir === 'desc' && previousSort.index === index }",
                                    @click.stop="sortResults('earnings', 'desc', index)"
                                )
                                    +icon-arrow-sort_down_filled
                            div 
                                span(v-if="parseFloat(wGroupEarnings[index]) > 0", class="fg-70 fg-primary text-right weighted") {{ wGroupEarnings[index] }}
                                span(v-else, class="weighted text-right") -
                        ib-table-col(width="12ch")
                            div(class="border-bottom", @click.stop="sortResults('eps_growth', '', index)")
                                span(:title="$t('eps_growth')") {{ $t('eps_growth') }} %
                                span(
                                    class="up", 
                                    :class="{'active-sort': previousSort.type === 'eps_growth' && previousSort.dir === 'asc' && previousSort.index === index }", 
                                    @click.stop="sortResults('eps_growth', 'asc', index)"
                                )
                                    +icon-arrow-sort_up_filled
                                span(
                                    class="down",
                                    :class="{'active-sort': previousSort.type === 'eps_growth' && previousSort.dir === 'desc' && previousSort.index === index }",
                                    @click.stop="sortResults('eps_growth', 'desc', index)"
                                )
                                    +icon-arrow-sort_down_filled
                            div
                                span(class="fg-70 fg-primary text-right weighted") {{ wGroupEpsGrowth[index] }}%
                        ib-table-col(width="8ch")
                            div(class="border-bottom", @click.stop="sortResults('div', '', index)")
                                span(:title="$t('div')") {{ $t('div') }} %
                                span(
                                    class="up", 
                                    :class="{'active-sort': previousSort.type === 'div' && previousSort.dir === 'asc' && previousSort.index === index }", 
                                    @click.stop="sortResults('div', 'asc', index)"
                                )
                                    +icon-arrow-sort_up_filled
                                span(
                                    class="down",
                                    :class="{'active-sort': previousSort.type === 'div' && previousSort.dir === 'desc' && previousSort.index === index }",
                                    @click.stop="sortResults('div', 'desc', index)"
                                )
                                    +icon-arrow-sort_down_filled
                            div
                                span(v-if="parseFloat(wGroupDY[index]) > 0", class="fg-70 fg-primary text-right weighted") {{ wGroupDY[index] }}%
                                span(v-else, class="weighted text-right") -
                        ib-table-col(width="7ch")
                            div(class="border-bottom", @click.stop="sortResults('pe', '', index)")
                                span(:title="$t('pe')") {{ $t('pe') }}
                                span(
                                    class="up", 
                                    :class="{'active-sort': previousSort.type === 'pe' && previousSort.dir === 'asc' && previousSort.index === index }", 
                                    @click.stop="sortResults('pe', 'asc', index)"
                                )
                                    +icon-arrow-sort_up_filled
                                span(
                                    class="down",
                                    :class="{'active-sort': previousSort.type === 'pe' && previousSort.dir === 'desc' && previousSort.index === index }",
                                    @click.stop="sortResults('pe', 'desc', index)"
                                )
                                    +icon-arrow-sort_down_filled
                            div
                                span(v-if="parseFloat(wGroupPES[index]) > 0", class="fg-70 fg-primary text-right weighted") {{ wGroupPES[index] }}
                                span(v-else, class="weighted text-right") -
                        ib-table-col(width="7ch")
                            div(class="border-bottom", @click.stop="sortResults('peg', '', index)")
                                span(:title="$t('peg')") {{ $t('peg') }}
                                span(
                                    class="up", 
                                    :class="{'active-sort': previousSort.type === 'peg' && previousSort.dir === 'asc' && previousSort.index === index }", 
                                    @click.stop="sortResults('peg', 'asc', index)"
                                )
                                    +icon-arrow-sort_up_filled
                                span(
                                    class="down",
                                    :class="{'active-sort': previousSort.type === 'peg' && previousSort.dir === 'desc' && previousSort.index === index }",
                                    @click.stop="sortResults('peg', 'desc', index)"
                                )
                                    +icon-arrow-sort_down_filled
                            div
                                span(v-if="parseFloat(wGroupPEGS[index]) > 0", class="fg-70 fg-primary text-right weighted") {{ wGroupPEGS[index] }}
                                span(v-else, class="weighted text-right") -
                        template(slot="body", slot-scope="company")
                            td(class="padding-zero", v-if="!$media.xl")
                                span(class="info results", @click="showResultModal(company)")
                                    +icon-basic-info_filled
                            td(@click="getMoreInfo", class="row_tracker", :data-conid="company['conid']", :title="formatComp(company['company'])") {{ formatComp(company['company']) }}
                            td(
                                @click="getMoreDetails(company['company'], company['conid'])", 
                                :title="company['ticker']"
                            )
                                span(class="fg-accent") {{ company['ticker'] }}
                            td(@click="getMoreInfo", :title="company['company_cntry']", v-text="company['company_cntry']")
                            td(@click="getMoreInfo", :title="company['industry']", v-text="company['industry']")
                            td(@click="getMoreInfo", :title="company['conv_price']")
                                div(v-if="!company['conv_price']" class="spin")
                                span(v-else, class="text-right weighted") {{ company['conv_price'] }}
                            td(@click="getMoreInfo", :title="getFormat(company['conv_mkt_cap'])", class="text-right") {{ getFormat(company['conv_mkt_cap']) }}
                            td(@click="getMoreInfo", :title="getFormat(company['conv_ev_cur'])", class="text-right") {{ getFormat(company['conv_ev_cur']) }}
                            td(@click="getMoreInfo", :title="setExchRev(company['ttmrev'])", class="text-right") {{ setExchRev(company['ttmrev']) }}
                            td(@click="getMoreInfo", :title="setExchNI(company['ttmebitd'])", class="text-right") {{ setExchNI(company['ttmebitd']) }}
                            td(@click="getMoreInfo", :title="getGrowth(company['epsgrpct'])", class="text-right") {{ getGrowth(company['epsgrpct'])  }}
                            td(@click="getMoreInfo", :title="getYield(company['divyield'])", class="text-right") {{ getYield(company['divyield']) }}
                            td(@click="getMoreInfo", :title="getFixed(company['peexclxor'])", class="text-right") {{ getFixed(company['peexclxor']) }}
                            td(@click="getMoreInfo", :title="getRatio(company['peg'])", class="text-right") {{ getRatio(company['peg']) }}
    InfoModal(v-if="picked !== null", :picked="picked", :type="type", ref="groupInfoModal")
    DetailsModal(ref="detailInfo")
    ib-dialog(
        :autoclose="true",
        ref="modal",
        v-model="showLoginScreen"
    )
        div(class="inner-modal")
            div(class="add-info flex-fixed top")
                h3 {{ $t('login') }}
                a(@click="closeModal")
                    span(class="fg")
                        +icon-basic-cancel
            div(class="modal-body")
                h5(class="text-center") {{ $t('login_to_portal') }}
                p(class="text-center")
                    ib-button(class="bg-accent _btn act", @click.prevent="addFilters")  {{ $t('have_existing_account') }}
                br
                h5(class="text-center") {{ $t('no_account') }} {{ $t('open_one') }}
                p(class="text-center after-16")
                    a(class="bg-accent _btn act" href="https://www.interactivebrokers.com/en/index.php?f=4695") {{ $t('open_ib_account') }}
           
    </template>

<script>
import { mapState, mapActions } from 'vuex';
import ChangeCurrency from './ChangeCurrency.vue';
import InfoModal from './InfoModal.vue';
import CurrencySelector from './CurrencySelector.vue';
import DetailsModal from './DetailsModal.vue';
import { formatMixin } from '../js/formatting.js';
import { priceMixin } from '../js/price.js';


const sso = 'https://www.interactivebrokers.com/sso/Login';

export default {
    name: 'SearchResultsGroups',
    components: {
        ChangeCurrency,
        InfoModal,
        CurrencySelector,
        DetailsModal
    },
    data() {
        return {
            editCurr: '',
            curResults: [],
            direction: true,
            show: false,
            showLoginScreen: false,
            curResultsMapping: new Map(),
            type: 'stock',
            picked: null,
            previousSort: { type: 'mkt_cap', dir: 'desc', index: 0 }, // This is the default
        
            wGroupCaps:[],
            wGroupEVs: [],
            wGroupRevs: [],
            wGroupEarnings: [],
            wGroupEpsGrowth: [],
            wGroupDY: [],
            wGroupPES: [],
            wGroupPEGS: [],
        }
    },
    mixins: [formatMixin, priceMixin],
    methods: {
        showResultModal(res) {
            this.picked = res;
            Vue.nextTick(()=> {
                this.$refs.groupInfoModal.show();
            })
        },
        addFilters() {
            window.location.href = `${sso}`;
        },
        updateResults() {
            console.log("updateResults called");
            this.curResults = [];
            this.previousSort = { type: 'mkt_cap', dir: 'desc', index: 0 };
            this.processResponse();
            this.getTotals();
        },
        closeModal() {
            this.showLoginScreen = false;
        },

        getMoreDetails(name, conid) {
            this.$refs.detailInfo.open(name, conid);
        },

        getMoreInfo() {
            if (!this.signedIn) {
                this.showLoginScreen = true;
            }
        },

        // Currency changed
        update() {
            this.search({})
                .then(() => this.updateResults());
        },

        getSelected(companies) {
            return companies.filter(comp => comp.selected).length;
        },

        // Creating the table output for each group
        processResponse() {
            this.curResults = [];
            const results = this.resultsResponse.res;
            const resultsMap = new Map();
            const resultsForGroup = [];
            for (let i = 0; i < results.length; i++) {
                resultsMap.set(results[i].id, results[i]);
            }
            Vue.nextTick(() => {
                this.groups.forEach((group, index) => {
                    resultsForGroup[index] = [];
                    resultsMap.forEach((val, key) => {
                        let companies = group.companies.filter(comp => comp.selected);
                        let validComp = companies.find(comp => comp.id === key);
                        if (validComp) {
                            let result = resultsMap.get(validComp.id);
                            resultsForGroup[index].push(result);
                        }
                    });
                });
                this.curResults = resultsForGroup;
                this.initialized('#search-res', '.row_tracker', true);
            });
        },

        //allow parent component Finexplorer to edit or start over with groups selected
        showForm(bool) {
                this.$emit("showForm", bool, "Company", this.passComp, this.passInd, 'Stocks');
        },

        sortResults(type, dir, index) {
            // Don't sort column again if already sorted.
            if (this.previousSort.type && (this.previousSort.type === type && this.previousSort.dir === dir && this.previousSort.index === index)) {
                return;
            }
            console.debug('Trying to sort group: ', index, type, dir);
            let sortedArray = this.curResults[index];

            const compareNumber = (a,b) => {
                let at = a;
                let bt = b;
                if (at === null || at === undefined) at = 0;
                if (bt === null || bt === undefined) bt = 0;
                at = parseFloat(at.toString().replace('%', ''));
                bt = parseFloat(bt.toString().replace('%', ''));
                return at > bt ? 1 : bt > at ? -1 : 0;
            }

            // We don't have to make an API call to sort, this can be done client-side in js.
            if (type === 'company') {
                sortedArray.sort((a,b) => a.company.localeCompare(b.company));
            }
            else if (type === 'ticker') {
                sortedArray.sort((a,b) => a.ticker.localeCompare(b.ticker));
            }
            else if (type === 'country') {
                sortedArray.sort((a,b) => a.company_cntry.localeCompare(b.company_cntry));
            }
            else if (type === 'sector') {
                sortedArray.sort((a,b) => a.industry.localeCompare(b.industry));
            }
            else if (type === 'mkt_cap') {
                sortedArray.sort((a,b) => compareNumber(a.conv_mkt_cap, b.conv_mkt_cap));
            }
            else if (type === 'ev') {
                sortedArray.sort((a,b) => compareNumber(a.conv_ev_cur, b.conv_ev_cur));
            }
            else if (type === 'rev') {
                sortedArray.sort((a,b) => compareNumber(a.ttmrev, b.ttmrev));
            }
            else if (type === 'earnings') {
                sortedArray.sort((a,b) => compareNumber(a.ttmebitd, b.ttmebitd));
            }
            else if (type === 'eps_growth') {
                sortedArray.sort((a,b) => compareNumber(a.epsgrpct, b.epsgrpct));
            }
            else if (type === 'div') {
                sortedArray.sort((a,b) => compareNumber(a.divyield, b.divyield));
            }
            else if (type === 'pe') {
                sortedArray.sort((a,b) => compareNumber(a.peexclxor, b.peexclxor));
            }
            else if (type === 'peg') {
                sortedArray.sort((a,b) => {
                    console.log('Values', a.peg, b.peg, a, b);
                    return compareNumber(a.peg, b.peg)
                });
            }

            if (dir === 'desc') {
                sortedArray.reverse();  
            }
            if (dir == '') {
                this.direction = !this.direction;
                if (this.direction) {
                    dir = 'desc';
                    sortedArray.reverse(); 
                } else {
                    dir = 'asc';
                }
            }
            this.previousSort.type = type;
            this.previousSort.dir = dir;
            this.previousSort.index = index;
            Vue.set(this.curResults, index, sortedArray);
        },
        getTotalsGroup(group, index, responses) {
            console.debug({group}, {index}, {responses});
            let finalResponses = [];

            //groupCaps will hold weight
            let groupCaps = [];

            let groupMktCaps = [];
            let groupEVs = [];
            let groupRevs = [];
            let groupEarn = [];
            let groupEpsGrowth = [];
            let groupDY = [];
            let groupPES = [];
            let groupPEGS = [];

            let companies = group.companies;
            console.debug({companies});
            companies.filter(comp => comp.selected).forEach(comp => {
                let val = '';
                val = responses.find(r => r.ticker === comp.ticker);
                finalResponses.push(val)
            })

            finalResponses.map(r => groupCaps.push(+r['conv_mkt_cap']));
            let sum = '';
            if (groupCaps.length > 1) {
                sum = groupCaps.reduce((prev, next) => prev + next);
            } else {
                sum = groupCaps[0];
            }

            console.debug('Go through each',finalResponses);
            finalResponses.map(r => {
                let weight = (+r['conv_mkt_cap']/sum);

                let wmktcap = weight * +r['conv_mkt_cap'];
                //console.log( "weight", "conv_mkt_cap", `${ weight }`, `${ +r['conv_mkt_cap'] }`);

                let wev = weight * +r['conv_ev_cur'];
                //console.log( "weight", "conv_ev_cur", `${ weight }`, `${ +r['conv_ev_cur'] }` );

                let wrev = weight * +r['ttmrev'];
                //console.log( "weight", "ttmrev", `${ weight }`, `${ +r['ttmrev'] }` );

                let wttmebitd = weight * +r['ttmebitd'];
                //console.log( "weight", "ttmebitd", `${ weight }`, `${ +r['ttmebitd'] }` )

                let wepsgrow = weight * +r['epsgrpct'];
                //console.log( "weight", "epsgrpct", `${ weight }`, `${ +r['epsgrpct'] }` )

                let wdiv = weight * +r['divyield'];
                //console.log( "weight", "divyield", `${ weight }`, `${ +r['divyield'] }` )

                let wpe = weight * +r['peexclxor'];
                //console.log( "weight", "peexclxor", `${ weight }`, `${ +r['peexclxor'] }` )

                let wpeg = weight * +r['peg'];
                //console.log( "weight", "peg", `${ weight }`, `${ +r['peg'] }` )

                groupMktCaps.push(wmktcap);
                groupEVs.push(wev);
                groupRevs.push(wrev);
                groupEarn.push(wttmebitd);
                groupEpsGrowth.push(wepsgrow);
                groupDY.push(wdiv);
                groupPES.push(wpe);
                groupPEGS.push(wpeg);
            });

            //  Set Weighted Mkt Caps

            let wCap = 0;
            if (groupMktCaps.length > 1) {
                wCap =  groupMktCaps.reduce((prev, next) => prev + next);
            } else {
                wCap =  groupMktCaps[0];
            }
            //console.log("weightedCaps:", wCap);
            let conv_wCap = "";
            if (wCap >= 1000000000000) {
                wCap = (wCap/1000000000000).toFixed(2);
                conv_wCap = `${wCap}T`;
            } else if (wCap < 1000000000000 && wCap >= 1000000000) {
                wCap = (wCap/1000000000).toFixed(2);
                conv_wCap = `${wCap}B`;
            } else {
                wCap = (wCap/1000000).toFixed(2);
                conv_wCap = `${wCap}M`; 
            }
            this.wGroupCaps[index] = conv_wCap;

            //  Set Weighted EVs

            let wEVS = 0;
            if (groupEVs.length > 1) {
                wEVS = groupEVs.reduce((prev, next) => prev + next);
            } else {
                wEVS = groupEVs[0];
            }
            //console.log("weightedEVS:", wEVS);
            let conv_wEVS = "";
            if (wEVS >= 1000000000000) {
                wEVS = (wEVS/1000000000000).toFixed(2);
                conv_wEVS = `${wEVS}T`;
            } else if (wEVS < 1000000000000 && wEVS >= 1000000000) {
                wEVS = (wEVS/1000000000).toFixed(2);
                conv_wEVS = `${wEVS}B`;
            } else {
                wEVS = (wEVS/1000000).toFixed(2);
                conv_wEVS = `${wEVS}M`;
            }
            this.wGroupEVs[index] = conv_wEVS;

            //  Set Revenue

            let wRevs = 0;
            if (groupRevs.length > 1) {
                wRevs = groupRevs.reduce((prev, next) => prev + next);
            } else {
                wRevs = groupRevs[0];
            }
            let conv_wRevs = "";
            if (wRevs >= 1000000) {
                wRevs = (wRevs/1000000).toFixed(2);
                conv_wRevs = `${wRevs}T`;
            } else if (wRevs < 1000000 && wRevs >= 1000) {
                wRevs = (wRevs/1000).toFixed(2);
                conv_wRevs = `${wRevs}B`;
            } else {
                wRevs = wRevs.toFixed(2);
                conv_wRevs = `${wRevs}M`;
            }
            this.wGroupRevs[index] = conv_wRevs;

            //  Set Earnings

            let filteredEarn = groupEarn.filter(ern => ern > 0);
            if (filteredEarn.length === 0) {
                filteredEarn.push(...groupEarn);
            }
            //console.log("filteredEarn:", filteredEarn);
            let wEarn = 0;
            if (filteredEarn.length > 1) {
                wEarn = filteredEarn.reduce((prev, next) => prev + next);
            } else {
                wEarn = filteredEarn[0];
            }
            //console.log("weightedEarn:", wEarn);
            let conv_wEarn = "";
            if (wEarn >= 1000000) {
                wEarn = (wEarn/1000000).toFixed(2);
                conv_wEarn = `${wEarn}T`;
            } else if (wEarn < 1000000 && wEarn >= 1000) {
                wEarn = (wEarn/1000).toFixed(2);
                conv_wEarn = `${wEarn}B`;
            } else {
                wEarn = wEarn.toFixed(2);
                conv_wEarn = `${wEarn}M`;
            }
            this.wGroupEarnings[index] = conv_wEarn;

            // Set EPS Growth

            let wEPS = 0;
            if (groupEpsGrowth.length > 1) {
                wEPS = groupEpsGrowth.reduce((prev, next) => prev + next);
            } else {
                wEPS = groupEpsGrowth[0];
            }
            this.wGroupEpsGrowth[index] = wEPS.toFixed(2);

            // Set Dividend Yield
            
            let filterDY = groupDY.filter(dy => dy > 0);
            if (filterDY.length === 0) {
                filterDY.push(...groupDY);
            }
            //console.log("filterDY:", filterDY);
            let wDY = 0;
            if (filterDY.length > 1) {
                wDY = filterDY.reduce((prev, next) => prev + next);
            } else {
                wDY = filterDY[0];
            }
            this.wGroupDY[index] = wDY.toFixed(2);
            
            //Set PE

            let filteredPE = groupPES.filter(pe => pe > 0);
            if (filteredPE.length === 0 ) {
                filteredPE.push(...groupPES)
            }
            //console.log("filteredPE:", filteredPE);
            let wPE = 0;
            if (filteredPE.length > 1) {
                wPE = filteredPE.reduce((prev, next) => prev + next);
            } else {
                wPE = filteredPE[0];
            }
            this.wGroupPES[index] = wPE.toFixed(2);

            //Set PEG
            let filteredPEG = groupPEGS.filter(peg => peg > 0);
            if (filteredPEG.length === 0) {
                filteredPEG.push(...groupPEGS)
            }
            let wPEG = 0;
            if (filteredPEG.length > 1) {
                wPEG = filteredPEG.reduce((prev, next) => prev + next);
            } else {
                wPEG = filteredPEG[0];
            }
            this.wGroupPEGS[index] = wPEG.toFixed(2);
        },
        getTotals() {
            this.groups.forEach((group, index) => {
                this.getTotalsGroup(group, index, this.resultsResponse.res);
            });
        },
        selectedGroup(index) {
            return this.curResults[index];
        },
        startOver() {
            this.reset();
        },
        ...mapActions(['reset','search'])
    },
    computed: {
        resultsResponse: function() {
            return this.listedResults;
        },
        ...mapState(['groups', 'marketDataPrices', 'currencyConversions', 'listedResults'])
    },
    mounted() { 
        this.updateResults();
    },
}
</script>

<style lang="less" scoped>
    ._con {
        svg {
            width: 1em;
            height: 1em;
        }
    }
    span {
        .up {
            position: relative;
            right: -6px;
            top: -6px;
            &.active-sort {
                color: #000;
            }
        }
        .down {
            position: relative;
            left: -5px;
            top: 4px;
            &.active-sort {
                color: #000;
            }
        }
    }
    .weighted {
        display: block;
    }
    .after_table {
        margin-bottom: 36px;
    }
</style>
